import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import PhotoIcon from '@material-ui/icons/Photo';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';

import {
  ButtonsWrapper,
  ButtonWrapper,
  StyledButton,
  StyledInputFile,
  StyledInputFileWrapper,
  ButtonLabel,
} from './UploaderButtons.styles';

const UploaderButtons = ({
  handleCapturePhoto,
  handleSelectFile,
  photoDisabled,
  galleryDisabled,
}) => {
  const { t } = useTranslation();
  const { online } = useSelector((state) => state.offline);

  return (
    <ButtonsWrapper>
      <ButtonWrapper>
        <StyledButton
          disabled={photoDisabled}
          theme="secondary"
          aria-label="capture_photo"
          type="button"
          onClick={handleCapturePhoto}
        >
          <PhotoCameraIcon color={photoDisabled ? 'disabled' : 'secondary'} />
        </StyledButton>
        <ButtonLabel>{t('camera_button_photo')}</ButtonLabel>
      </ButtonWrapper>

      <ButtonWrapper htmlFor="file-input">
        <StyledInputFileWrapper>
          <StyledInputFile
            id="file-input"
            name="file-input"
            type="file"
            onChange={handleSelectFile}
            multiple="multiple"
            accept={online ? 'image/*,video/*' : 'image/*'}
            disabled={galleryDisabled}
          />
          <label htmlFor="file-input">
            <PhotoIcon color="secondary" />
          </label>
        </StyledInputFileWrapper>
        <ButtonLabel>{t('camera_button_gallery')}</ButtonLabel>
      </ButtonWrapper>
    </ButtonsWrapper>
  );
};

UploaderButtons.propTypes = {
  handleCapturePhoto: PropTypes.func,
  handleSelectFile: PropTypes.func,
  photoDisabled: PropTypes.bool,
  galleryDisabled: PropTypes.bool,
};

export default UploaderButtons;
